import React from "react";
import { Props } from "./types";

function CommentIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 14.565 14.565">
      <path
        d="M16.108,3H4.456A1.455,1.455,0,0,0,3.007,4.456L3,17.565l2.913-2.913h10.2A1.461,1.461,0,0,0,17.565,13.2V4.456A1.461,1.461,0,0,0,16.108,3Zm-1.456,8.739H5.913V10.282h8.739Zm0-2.185H5.913V8.1h8.739Zm0-2.185H5.913V5.913h8.739Z"
        transform="translate(-3 -3)"
      />
    </svg>
  );
}

export { CommentIcon };
